var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "btn-group" },
    [
      _c("el-tooltip", { attrs: { content: "Export Messages" } }, [
        _vm.canExport
          ? _c(
              "button",
              {
                staticClass: "btn btn-secondary btn-sm",
                on: { click: _vm.exportHandler },
              },
              [_c("i", { staticClass: "fas fa-download" })]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("el-tooltip", { attrs: { content: "Delete" } }, [
        _vm.canDelete
          ? _c(
              "button",
              {
                staticClass: "btn btn-danger btn-sm",
                on: { click: _vm.confirmDeleting },
              },
              [_c("i", { staticClass: "fas fa-trash-alt" })]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }